
import { each, has } from 'underscore';
import { IValidationMessages} from '../../../model/common/error/error.model'; 
import { ErrorCode} from '../../../model/common/error/errorcode.enum'; 

export class MessageService {

    private $translate: ng.translate.ITranslateService;

    public static $inject: Array<string> = ["$translate"];
    constructor($translate: ng.translate.ITranslateService) {
        this.$translate = $translate;
    }

    public getLocalisedMessageList(validationMessages: Array<IValidationMessages> = []): Array<string> {
        let msgList: Array<string> = [];
        each(validationMessages, (msg: IValidationMessages) => {
            if (msg && msg.Key) {
                let errorKey = this.getMessageKey(msg.Key.toString());
                errorKey && msgList.push(this.$translate.instant(errorKey, { text: msg.Message }));
            }
        });

        if (msgList.length <= 0) {
            msgList.push(this.$translate.instant("VALIDATION.ERRORINPROCESSING"));
        }
        return msgList;
    }


    getMessageKey(key: string ): string {
        let msg = "";
        if (has(ErrorCode, key)) {
            msg = ErrorCode[key].replace(/\_/g, '.');
        }
        return msg;
    }
}